import { Box, Container, Typography, Divider, Chip, Avatar } from "@mui/material";
import { format } from "date-fns";
import { Link } from "react-router-dom";
import { useGetPublicSchoolInfoQuery } from "../../../../../app/authApiSlice";
import { useGetWebsiteSettingsQuery } from "../../../../../app/websiteApiSlice";
import WebsiteHeader from "../../WebsiteHeader";
import WebsiteFooter from "../../WebsiteFooter";
import SeoHead from "../../SeoHead";
import "./classic.css";

export default function ClassicPost({ post, settings: settingsProp }) {
  const { data: school } = useGetPublicSchoolInfoQuery();
  const { data: settings } = useGetWebsiteSettingsQuery(undefined, { skip: !!settingsProp });
  const activeSettings = settingsProp || settings;

  return (
    <Box className="website-classic" sx={{ minHeight: "100vh", display: "flex", flexDirection: "column", bgcolor: "#fdfaf5" }}>
      <SeoHead title={post.seo_title || post.title} description={post.seo_description || post.excerpt} ogImage={post.seo_og_image || post.featured_image} schoolName={school?.name} />
      <WebsiteHeader school={school} navItems={activeSettings?.nav_items} variant="classic" />

      {post.featured_image && (
        <Box component="img" src={post.featured_image} alt={post.title}
          sx={{ width: "100%", maxHeight: 380, objectFit: "cover", borderBottom: "4px solid #795548" }}
        />
      )}

      <Container maxWidth="md" sx={{ py: 6, flex: 1 }}>
        <Box display="flex" gap={0.5} mb={2}>
          {post.categories?.map((c) => (
            <Chip key={c.id} label={c.name} size="small"
              sx={{ bgcolor: "#795548", color: "white" }}
              component={Link} to={`/blog/category/${c.slug}`} clickable
            />
          ))}
        </Box>
        <Typography variant="h3" fontWeight={700} sx={{ fontFamily: "Georgia, serif", mb: 1 }}>{post.title}</Typography>
        <Box display="flex" alignItems="center" gap={1} mb={1} color="text.secondary">
          <Typography variant="body2" sx={{ fontStyle: "italic" }}>
            By {post.author?.username}
            {post.published_at ? `, ${format(new Date(post.published_at), "MMMM d, yyyy")}` : ""}
          </Typography>
        </Box>
        <Divider sx={{ borderColor: "#795548", borderWidth: 2, mb: 4 }} />
        <Box className="prose-content" dangerouslySetInnerHTML={{ __html: post.content }} />
      </Container>

      <WebsiteFooter settings={activeSettings} school={school} variant="classic" />
    </Box>
  );
}
